
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as ParentDU_tGC6idbUhZ3Dv_cW_45brP7EIAcX_45We6ky2JZlE7_oMeta } from "/app/pages/Parent.vue?macro=true";
import { default as newpageIF80x4H_df7Vj4t9d8OJ040eBFHm0FrtOcsaVg75_45_454Meta } from "/app/pages/newpage.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as indexwKCtQ8k2La_0qqvleGVG0tlb7IIuCs1Rkt4Gt529JXoMeta } from "/app/pages/fees/index.vue?macro=true";
import { default as indexrrFt8wygNZN9vggq4I9qi8L0tvMDB0QJ8iyzj0MNxrUMeta } from "/app/pages/rsvp/index.vue?macro=true";
import { default as help_45centerP51bOMrVciwgxDATlNLYT__iJAWtimsaSAcvswwmgL4Meta } from "/app/pages/help-center.vue?macro=true";
import { default as indexwqqxPBLNl0Gqxy2G7X4gCBzRids0_eE4yk9P0pmntIkMeta } from "/app/pages/users/index.vue?macro=true";
import { default as indexrDqMSVkmqJ_45K4ru_jaNFtZOaP2MAuxd4p4vlycfVaVcMeta } from "/app/pages/events/index.vue?macro=true";
import { default as unauthorized17NYwdK_vpXoMmVXmhdTSn6CG_AM5wMHLBy01ScJbgcMeta } from "/app/pages/unauthorized.vue?macro=true";
import { default as indexcu9RRixiQhk3citi9tha2a9q9IhoGXufYxaKfcpJ_45KgMeta } from "/app/pages/program/index.vue?macro=true";
import { default as indexwCRMa6IyY3Kzh5oRRqSJn_45oJ3qwiLvZ_JxeCfcfBrFcMeta } from "/app/pages/families/index.vue?macro=true";
import { default as indexFkdI_676CBlXATGky8A2iwXeHfuzaO_45bgKayVtD4S_MMeta } from "/app/pages/invoices/index.vue?macro=true";
import { default as indexSDsiR6XePZOTPJ9asSb52TzyLxKi2rbSUa4sHAsAixcMeta } from "/app/pages/programs/index.vue?macro=true";
import { default as index7ybJx6bgYQyPpJr_kUg6fwBcu6XgxawzWjOX2G5u3TwMeta } from "/app/pages/students/index.vue?macro=true";
import { default as indextgYusPB7UTQCcnEGFiilrEYV3TdgjgIjrgjrbiY7lIEMeta } from "/app/pages/audit-log/index.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as indexLRz8Bo08mY_45tVnEWEc37daoFtQ7ven5hksm35c3lJacMeta } from "/app/pages/discounts/index.vue?macro=true";
import { default as indexkVNJtu_oKyx9p8LsQTcqmdxGYp6ku05TmOwoJhFF6_8Meta } from "/app/pages/rsvp/[id]/index.vue?macro=true";
import { default as event_45attendance_WKWbGMJCqWzFkewuiDOHMM7XXltXqH0rHkvACnL8woMeta } from "/app/pages/event-attendance.vue?macro=true";
import { default as qrfQ_45IPT_45ZJO5ykWf8lp0mEErSFAlQbv5LOBJEkqnP6iAMeta } from "/app/pages/feed/[clubid]/qr.vue?macro=true";
import { default as ms_45redirect_45hereVnxqu4tWOWv6ZtH_G17gUuOVD39iW1YUFzjaxAKJoTYMeta } from "/app/pages/ms-redirect-here.vue?macro=true";
import { default as index9TnfqG750YCDiRsupZBs4eO9E0jv9z6OiYitQ3jywbQMeta } from "/app/pages/my-profile/index.vue?macro=true";
import { default as all7s4CpEP4m99l4Bi1OzL01ZkE4Y6QdX0P2_udtw7DL1MMeta } from "/app/pages/participants/all.vue?macro=true";
import { default as historyGrVIYy9u11hSc2keHkILf6pASAbZ4ylfakkmTeVramMMeta } from "/app/pages/payments/history.vue?macro=true";
import { default as indexZersxnjcWH6cm3TNor0I8_4XiXAga7qCsZlV_NScjlkMeta } from "/app/pages/events/[id]/index.vue?macro=true";
import { default as add_45updateUEnFoTnmYiB2MF7Yj6QITjri8vFdPVgGVywSmoQ_453z4Meta } from "/app/pages/events/add-update.vue?macro=true";
import { default as index6L92GUnZ8eGMg5Fj1LGwPpHz3IGzjj3Lkw0xelHquRsMeta } from "/app/pages/transaction/index.vue?macro=true";
import { default as dashboardJDiRWVvHiVd_SrgQkbiIEoM4QeF0ZqAblPoF6CrJik0Meta } from "/app/pages/database/dashboard.vue?macro=true";
import { default as attendance56PxVUS23BFhsuBIzy8pf7HsjNquZIsAY31TsYDWWP4Meta } from "/app/pages/reports/attendance.vue?macro=true";
import { default as index_5HwpLrspoiI5mMsZ2v7BiAd_455ZbC0fV3ovhMZA0zOEMeta } from "/app/pages/transactions/index.vue?macro=true";
import { default as indexa3Ela0_45nQK2A6izSMQ0R1EuD01bAVL6FkkulfwE1LT0Meta } from "/app/pages/[companyname]/index.vue?macro=true";
import { default as indexoL0AB1XSlQU9yysVQgEuIqaIYgQriiVi6UZxOn13JxEMeta } from "/app/pages/announcements/index.vue?macro=true";
import { default as ticketspqbT_457nM96pN7J_45CloW2EjMyuEqoglPf_XzWNplqL1cMeta } from "/app/pages/events/[id]/tickets.vue?macro=true";
import { default as profilevLO6xioOXW8IhbwWYA_mrpgwBEGwhyjrutTNwZ_45sS4YMeta } from "/app/pages/super-admin/profile.vue?macro=true";
import { default as revenue5Bw4n_45lZxwca_qstzjRq4fpFVtql5YYNnhu_yaVxpYEMeta } from "/app/pages/super-admin/revenue.vue?macro=true";
import { default as plans__45br0KtTzQEmWQ_TIt2wjWbW3sJe95OYlQQ26fbVXI0Meta } from "/app/pages/text-messaging/plans.vue?macro=true";
import { default as _91id_93n44nGXDTlXtOu9s06vbDJZtCQ3JJT8hldDrvjat3YEQMeta } from "/app/pages/database/records/[id].vue?macro=true";
import { default as listZuu1UoUQRi8L6mYEPjXMtKoD6NlUk2PH8pYVwUoHHNUMeta } from "/app/pages/database/records/list.vue?macro=true";
import { default as stripe_45connectIljJNsEfOw9EcGipNFdimz35ncQjFexRcvrCJh2vaXAMeta } from "/app/pages/portal/stripe-connect.vue?macro=true";
import { default as companiesU2d5iCTb9HzPZUZE03xLvpAJZ9tzhZ1EjnGVqAPxgGoMeta } from "/app/pages/super-admin/companies.vue?macro=true";
import { default as dashboardBDMJoZw_45M4DhMEtJZxRavVSHZGx8MHGQwiVr_45tOYQJ4Meta } from "/app/pages/super-admin/dashboard.vue?macro=true";
import { default as transfers1q05Dhql9TwH_45FP89tS7RR_60WOajMHa3uJEfUkK_45bcMeta } from "/app/pages/super-admin/transfers.vue?macro=true";
import { default as indexOXZAWHPOX1qRWqKb0duv9lVEBuxS6O0WbfbsFcsGa8wMeta } from "/app/pages/custom-questions/index.vue?macro=true";
import { default as oldIdb11_45tolAcERN3SrB8pcKNzpSgJrvGPpK1tufoupNZHAMeta } from "/app/pages/database/records/oldId.vue?macro=true";
import { default as approvalKSq5NyiAcaU1I8D1pwLvyZ0P0goEJnaN6SMtQvHC4QAMeta } from "/app/pages/feed/[clubid]/approval.vue?macro=true";
import { default as indexLIvsbBuy_YWEVhqbsDvhFR_wDWwtF9B0veBJbSaRvS0Meta } from "/app/pages/participants/[id]/index.vue?macro=true";
import { default as event_45attendance_45scannerXrbONctk28AHiRpIXuixHEXGadImTbhvFZOUogfuVxEMeta } from "/app/pages/event-attendance-scanner.vue?macro=true";
import { default as change_45passwordjja1DGbxyBbgrkPdSAd_45z3bFrqeE2HCdZ29x7X2JpeoMeta } from "/app/pages/my-profile/change-password.vue?macro=true";
import { default as seller_45accountWUQSArsYa6yN4hN9WM2zL5PGNZ4cItfnLbpy18Z5wYUMeta } from "/app/pages/super-admin/seller-account.vue?macro=true";
import { default as contest_45adminfQfH9T1WqQgs_45DDUJsoxHm_JVSWFtoHI_JJfDZkvT6MMeta } from "/app/pages/feed/[clubid]/contest-admin.vue?macro=true";
import { default as photo_45gallerytq66HYlgxgv7SmBOdTG9IJPl_45R37E5aQWgYZjjUfFLIMeta } from "/app/pages/feed/[clubid]/photo-gallery.vue?macro=true";
import { default as plansWfLfNhqBZQ7kFptTwz3bCKZVwRCn2u0_h8iy62whWIMMeta } from "/app/pages/no-auth/text-messaging/plans.vue?macro=true";
import { default as history_45for_45programrOWZAjid99gwkRWwYKm_ezW48XAS2wQwqTkZ8cPwhJ4Meta } from "/app/pages/payments/history-for-program.vue?macro=true";
import { default as transactionAUQ78nptQYDZ2S0DycZE312MV_45aZUoFXjRI5H46Y3lQMeta } from "/app/pages/program/[clubId]/transaction.vue?macro=true";
import { default as usage_45historyW_rh2bUeRM2aTRXD2u_TG3S14s1v2D9hfhWI0a7DUyIMeta } from "/app/pages/text-messaging/usage-history.vue?macro=true";
import { default as payment_45successDAhoaTklGMJGoiFRYXz37pYk1UGYIZ0fxu1KDDIkbBwMeta } from "/app/pages/text-messaging/payment-success.vue?macro=true";
import { default as indexv1rZDmbLziZzmuJ2rudaNp4re5bl2t0aoaUYmjpLd5MMeta } from "/app/pages/registration-form-builder/index.vue?macro=true";
import { default as indexunjymfxftN51HRwdE_454Y7XIeWHYC_45H2MS293a1DM5WsMeta } from "/app/pages/feed/[companycode]/[clubid]/index.vue?macro=true";
import { default as _91encodedemail_93wpMz23e4BJjrqXPzgQWwNOzvrDszzPxEu4pf0rHQAnsMeta } from "/app/pages/[companyname]/rsvp/[id]/[encodedemail].vue?macro=true";
import { default as payment_45successa1EiOSNWuppO_45QtS_qfEV3g1mitcpZ3jdnx4DR1wNUsMeta } from "/app/pages/no-auth/text-messaging/payment-success.vue?macro=true";
import { default as new_45contestSoD2F_45Z2AdEvezYFuA4ymMwBNM7otiUMGVE3Ux8r44MMeta } from "/app/pages/feed/[companycode]/[clubid]/new-contest.vue?macro=true";
import { default as _91redirectpath_93wNVsIyPAEWaMVAZsBljdyGfYOWTGrSHjnsR3SRDdTM8Meta } from "/app/pages/junction/short-id-validate/[shortid]/[redirectpath].vue?macro=true";
import { default as backup_45_91encodedemail_93_45with_45adult_45childI9p2e0cXQFh9B7M0USFRZMkmzjZ145hnzYJwYiB6XT8Meta } from "/app/pages/[companyname]/rsvp/[id]/backup-[encodedemail]-with-adult-child.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "Parent",
    path: "/Parent",
    meta: { ...(ParentDU_tGC6idbUhZ3Dv_cW_45brP7EIAcX_45We6ky2JZlE7_oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/Parent.vue")
  },
  {
    name: "newpage",
    path: "/newpage",
    component: () => import("/app/pages/newpage.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "fees",
    path: "/fees",
    meta: { ...(indexwKCtQ8k2La_0qqvleGVG0tlb7IIuCs1Rkt4Gt529JXoMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/fees/index.vue")
  },
  {
    name: "rsvp",
    path: "/rsvp",
    meta: { ...(indexrrFt8wygNZN9vggq4I9qi8L0tvMDB0QJ8iyzj0MNxrUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/rsvp/index.vue")
  },
  {
    name: "help-center",
    path: "/help-center",
    meta: { ...(help_45centerP51bOMrVciwgxDATlNLYT__iJAWtimsaSAcvswwmgL4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/help-center.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexwqqxPBLNl0Gqxy2G7X4gCBzRids0_eE4yk9P0pmntIkMeta || {},
    component: () => import("/app/pages/users/index.vue")
  },
  {
    name: "events",
    path: "/events",
    meta: { ...(indexrDqMSVkmqJ_45K4ru_jaNFtZOaP2MAuxd4p4vlycfVaVcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/events/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/app/pages/unauthorized.vue")
  },
  {
    name: "program",
    path: "/program",
    meta: indexcu9RRixiQhk3citi9tha2a9q9IhoGXufYxaKfcpJ_45KgMeta || {},
    component: () => import("/app/pages/program/index.vue")
  },
  {
    name: "families",
    path: "/families",
    meta: indexwCRMa6IyY3Kzh5oRRqSJn_45oJ3qwiLvZ_JxeCfcfBrFcMeta || {},
    component: () => import("/app/pages/families/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: { ...(indexFkdI_676CBlXATGky8A2iwXeHfuzaO_45bgKayVtD4S_MMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/invoices/index.vue")
  },
  {
    name: "programs",
    path: "/programs",
    meta: { ...(indexSDsiR6XePZOTPJ9asSb52TzyLxKi2rbSUa4sHAsAixcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/programs/index.vue")
  },
  {
    name: "students",
    path: "/students",
    meta: index7ybJx6bgYQyPpJr_kUg6fwBcu6XgxawzWjOX2G5u3TwMeta || {},
    component: () => import("/app/pages/students/index.vue")
  },
  {
    name: "audit-log",
    path: "/audit-log",
    meta: { ...(indextgYusPB7UTQCcnEGFiilrEYV3TdgjgIjrgjrbiY7lIEMeta || {}), ...{"middleware":["auth","audit-log-permission"]} },
    component: () => import("/app/pages/audit-log/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    meta: { ...(indexLRz8Bo08mY_45tVnEWEc37daoFtQ7ven5hksm35c3lJacMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/discounts/index.vue")
  },
  {
    name: "rsvp-id",
    path: "/rsvp/:id()",
    meta: { ...(indexkVNJtu_oKyx9p8LsQTcqmdxGYp6ku05TmOwoJhFF6_8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/rsvp/[id]/index.vue")
  },
  {
    name: "event-attendance",
    path: "/event-attendance",
    meta: { ...(event_45attendance_WKWbGMJCqWzFkewuiDOHMM7XXltXqH0rHkvACnL8woMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/event-attendance.vue")
  },
  {
    name: "feed-clubid-qr",
    path: "/feed/:clubid()/qr",
    meta: { ...(qrfQ_45IPT_45ZJO5ykWf8lp0mEErSFAlQbv5LOBJEkqnP6iAMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/feed/[clubid]/qr.vue")
  },
  {
    name: "ms-redirect-here",
    path: "/ms-redirect-here",
    component: () => import("/app/pages/ms-redirect-here.vue")
  },
  {
    name: "my-profile",
    path: "/my-profile",
    meta: { ...(index9TnfqG750YCDiRsupZBs4eO9E0jv9z6OiYitQ3jywbQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/my-profile/index.vue")
  },
  {
    name: "participants-all",
    path: "/participants/all",
    meta: { ...(all7s4CpEP4m99l4Bi1OzL01ZkE4Y6QdX0P2_udtw7DL1MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/participants/all.vue")
  },
  {
    name: "payments-history",
    path: "/payments/history",
    meta: { ...(historyGrVIYy9u11hSc2keHkILf6pASAbZ4ylfakkmTeVramMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/payments/history.vue")
  },
  {
    name: "events-id",
    path: "/events/:id()",
    meta: { ...(indexZersxnjcWH6cm3TNor0I8_4XiXAga7qCsZlV_NScjlkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/events/[id]/index.vue")
  },
  {
    name: "events-add-update",
    path: "/events/add-update",
    meta: add_45updateUEnFoTnmYiB2MF7Yj6QITjri8vFdPVgGVywSmoQ_453z4Meta || {},
    component: () => import("/app/pages/events/add-update.vue")
  },
  {
    name: "transaction",
    path: "/transaction",
    meta: { ...(index6L92GUnZ8eGMg5Fj1LGwPpHz3IGzjj3Lkw0xelHquRsMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/transaction/index.vue")
  },
  {
    name: "database-dashboard",
    path: "/database/dashboard",
    meta: dashboardJDiRWVvHiVd_SrgQkbiIEoM4QeF0ZqAblPoF6CrJik0Meta || {},
    component: () => import("/app/pages/database/dashboard.vue")
  },
  {
    name: "reports-attendance",
    path: "/reports/attendance",
    meta: { ...(attendance56PxVUS23BFhsuBIzy8pf7HsjNquZIsAY31TsYDWWP4Meta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/reports/attendance.vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    meta: { ...(index_5HwpLrspoiI5mMsZ2v7BiAd_455ZbC0fV3ovhMZA0zOEMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/transactions/index.vue")
  },
  {
    name: "companyname",
    path: "/:companyname()",
    meta: { ...(indexa3Ela0_45nQK2A6izSMQ0R1EuD01bAVL6FkkulfwE1LT0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/[companyname]/index.vue")
  },
  {
    name: "announcements",
    path: "/announcements",
    meta: indexoL0AB1XSlQU9yysVQgEuIqaIYgQriiVi6UZxOn13JxEMeta || {},
    component: () => import("/app/pages/announcements/index.vue")
  },
  {
    name: "events-id-tickets",
    path: "/events/:id()/tickets",
    meta: ticketspqbT_457nM96pN7J_45CloW2EjMyuEqoglPf_XzWNplqL1cMeta || {},
    component: () => import("/app/pages/events/[id]/tickets.vue")
  },
  {
    name: "super-admin-profile",
    path: "/super-admin/profile",
    meta: { ...(profilevLO6xioOXW8IhbwWYA_mrpgwBEGwhyjrutTNwZ_45sS4YMeta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/profile.vue")
  },
  {
    name: "super-admin-revenue",
    path: "/super-admin/revenue",
    meta: { ...(revenue5Bw4n_45lZxwca_qstzjRq4fpFVtql5YYNnhu_yaVxpYEMeta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/revenue.vue")
  },
  {
    name: "text-messaging-plans",
    path: "/text-messaging/plans",
    meta: { ...(plans__45br0KtTzQEmWQ_TIt2wjWbW3sJe95OYlQQ26fbVXI0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/text-messaging/plans.vue")
  },
  {
    name: "database-records-id",
    path: "/database/records/:id()",
    meta: { ...(_91id_93n44nGXDTlXtOu9s06vbDJZtCQ3JJT8hldDrvjat3YEQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/database/records/[id].vue")
  },
  {
    name: "database-records-list",
    path: "/database/records/list",
    meta: listZuu1UoUQRi8L6mYEPjXMtKoD6NlUk2PH8pYVwUoHHNUMeta || {},
    component: () => import("/app/pages/database/records/list.vue")
  },
  {
    name: "portal-stripe-connect",
    path: "/portal/stripe-connect",
    meta: stripe_45connectIljJNsEfOw9EcGipNFdimz35ncQjFexRcvrCJh2vaXAMeta || {},
    component: () => import("/app/pages/portal/stripe-connect.vue")
  },
  {
    name: "super-admin-companies",
    path: "/super-admin/companies",
    meta: { ...(companiesU2d5iCTb9HzPZUZE03xLvpAJZ9tzhZ1EjnGVqAPxgGoMeta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/companies.vue")
  },
  {
    name: "super-admin-dashboard",
    path: "/super-admin/dashboard",
    meta: { ...(dashboardBDMJoZw_45M4DhMEtJZxRavVSHZGx8MHGQwiVr_45tOYQJ4Meta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/dashboard.vue")
  },
  {
    name: "super-admin-transfers",
    path: "/super-admin/transfers",
    meta: { ...(transfers1q05Dhql9TwH_45FP89tS7RR_60WOajMHa3uJEfUkK_45bcMeta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/transfers.vue")
  },
  {
    name: "custom-questions",
    path: "/custom-questions",
    meta: indexOXZAWHPOX1qRWqKb0duv9lVEBuxS6O0WbfbsFcsGa8wMeta || {},
    component: () => import("/app/pages/custom-questions/index.vue")
  },
  {
    name: "database-records-oldId",
    path: "/database/records/oldId",
    meta: { ...(oldIdb11_45tolAcERN3SrB8pcKNzpSgJrvGPpK1tufoupNZHAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/database/records/oldId.vue")
  },
  {
    name: "feed-clubid-approval",
    path: "/feed/:clubid()/approval",
    meta: { ...(approvalKSq5NyiAcaU1I8D1pwLvyZ0P0goEJnaN6SMtQvHC4QAMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/feed/[clubid]/approval.vue")
  },
  {
    name: "participants-id",
    path: "/participants/:id()",
    meta: { ...(indexLIvsbBuy_YWEVhqbsDvhFR_wDWwtF9B0veBJbSaRvS0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/participants/[id]/index.vue")
  },
  {
    name: "event-attendance-scanner",
    path: "/event-attendance-scanner",
    component: () => import("/app/pages/event-attendance-scanner.vue")
  },
  {
    name: "my-profile-change-password",
    path: "/my-profile/change-password",
    meta: { ...(change_45passwordjja1DGbxyBbgrkPdSAd_45z3bFrqeE2HCdZ29x7X2JpeoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/my-profile/change-password.vue")
  },
  {
    name: "super-admin-seller-account",
    path: "/super-admin/seller-account",
    meta: { ...(seller_45accountWUQSArsYa6yN4hN9WM2zL5PGNZ4cItfnLbpy18Z5wYUMeta || {}), ...{"middleware":["super-admin-only"]} },
    component: () => import("/app/pages/super-admin/seller-account.vue")
  },
  {
    name: "feed-clubid-contest-admin",
    path: "/feed/:clubid()/contest-admin",
    meta: { ...(contest_45adminfQfH9T1WqQgs_45DDUJsoxHm_JVSWFtoHI_JJfDZkvT6MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/feed/[clubid]/contest-admin.vue")
  },
  {
    name: "feed-clubid-photo-gallery",
    path: "/feed/:clubid()/photo-gallery",
    meta: { ...(photo_45gallerytq66HYlgxgv7SmBOdTG9IJPl_45R37E5aQWgYZjjUfFLIMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/feed/[clubid]/photo-gallery.vue")
  },
  {
    name: "no-auth-text-messaging-plans",
    path: "/no-auth/text-messaging/plans",
    component: () => import("/app/pages/no-auth/text-messaging/plans.vue")
  },
  {
    name: "payments-history-for-program",
    path: "/payments/history-for-program",
    meta: history_45for_45programrOWZAjid99gwkRWwYKm_ezW48XAS2wQwqTkZ8cPwhJ4Meta || {},
    component: () => import("/app/pages/payments/history-for-program.vue")
  },
  {
    name: "program-clubId-transaction",
    path: "/program/:clubId()/transaction",
    meta: { ...(transactionAUQ78nptQYDZ2S0DycZE312MV_45aZUoFXjRI5H46Y3lQMeta || {}), ...{"middleware":["auth","admin-only"]} },
    component: () => import("/app/pages/program/[clubId]/transaction.vue")
  },
  {
    name: "text-messaging-usage-history",
    path: "/text-messaging/usage-history",
    meta: { ...(usage_45historyW_rh2bUeRM2aTRXD2u_TG3S14s1v2D9hfhWI0a7DUyIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/text-messaging/usage-history.vue")
  },
  {
    name: "text-messaging-payment-success",
    path: "/text-messaging/payment-success",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/text-messaging/payment-success.vue")
  },
  {
    name: "registration-form-builder",
    path: "/registration-form-builder",
    meta: indexv1rZDmbLziZzmuJ2rudaNp4re5bl2t0aoaUYmjpLd5MMeta || {},
    component: () => import("/app/pages/registration-form-builder/index.vue")
  },
  {
    name: "feed-companycode-clubid",
    path: "/feed/:companycode()/:clubid()",
    meta: indexunjymfxftN51HRwdE_454Y7XIeWHYC_45H2MS293a1DM5WsMeta || {},
    component: () => import("/app/pages/feed/[companycode]/[clubid]/index.vue")
  },
  {
    name: "companyname-rsvp-id-encodedemail",
    path: "/:companyname()/rsvp/:id()/:encodedemail()",
    meta: _91encodedemail_93wpMz23e4BJjrqXPzgQWwNOzvrDszzPxEu4pf0rHQAnsMeta || {},
    component: () => import("/app/pages/[companyname]/rsvp/[id]/[encodedemail].vue")
  },
  {
    name: "no-auth-text-messaging-payment-success",
    path: "/no-auth/text-messaging/payment-success",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/no-auth/text-messaging/payment-success.vue")
  },
  {
    name: "feed-companycode-clubid-new-contest",
    path: "/feed/:companycode()/:clubid()/new-contest",
    meta: new_45contestSoD2F_45Z2AdEvezYFuA4ymMwBNM7otiUMGVE3Ux8r44MMeta || {},
    component: () => import("/app/pages/feed/[companycode]/[clubid]/new-contest.vue")
  },
  {
    name: "junction-short-id-validate-shortid-redirectpath",
    path: "/junction/short-id-validate/:shortid()/:redirectpath()",
    component: () => import("/app/pages/junction/short-id-validate/[shortid]/[redirectpath].vue")
  },
  {
    name: "companyname-rsvp-id-backup-encodedemail-with-adult-child",
    path: "/:companyname()/rsvp/:id()/backup-:encodedemail()-with-adult-child",
    meta: backup_45_91encodedemail_93_45with_45adult_45childI9p2e0cXQFh9B7M0USFRZMkmzjZ145hnzYJwYiB6XT8Meta || {},
    component: () => import("/app/pages/[companyname]/rsvp/[id]/backup-[encodedemail]-with-adult-child.vue")
  }
]